import React from 'react'
import styled from '@emotion/styled'

interface RegistrationStatusPillProps {
  bg: string
  color: string
  icon?: React.ReactNode
  text?: string | null
  style?: React.CSSProperties
  absolute?: boolean
  top?: number | string
  left?: number | string
  className?: string
}

const Pill = styled.div<{
  bg: string
  color: string
  absolute?: boolean
  top?: number | string
  left?: number | string
}>`
  background: ${(props) => props.bg};
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 0.8em;
  font-weight: 600;
  border-radius: 16px;
  padding: 4px 12px;
  min-height: 28px;
  min-width: 80px;
  max-width: calc(100% - 8px);
  z-index: 3;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.18),
    0 1.5px 4px rgba(0, 0, 0, 0.12);
  pointer-events: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 1;
  ${(props) =>
    props.absolute
      ? `position: absolute; top: ${props.top ?? 8}px; left: ${props.left ?? '50%'}; transform: none;`
      : ''}
`

export const RegistrationStatusPill: React.FC<RegistrationStatusPillProps> = ({
  bg,
  color,
  icon,
  text,
  style,
  absolute = false,
  top,
  left,
  className
}) => {
  if (!text && !icon) return null
  return (
    <Pill bg={bg} color={color} absolute={absolute} top={top} left={left} style={style} className={className}>
      {icon}
      {text}
    </Pill>
  )
}
